// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dd7f7ac9","389":"a618820f","453":"e89ba1ab","455":"a6dd9f12","977":"3e6f4e5e"}[chunkId] + ".chunk.js";
};